export default class AddressService {
  static newAddress(address) {
    return $.ajax({
      type: 'POST',
      url: globalThis.FFJP.addressCreateEndPointUrl,
      data: JSON.stringify(address),
      crossDomain: true,
      dataType: 'json',
    })
  }

  static editAddress(address) {
    return $.ajax({
      type: 'POST',
      url: globalThis.FFJP.addressEditEndPointUrl,
      data: JSON.stringify(address),
      crossDomain: true,
      dataType: 'json',
    })
  }

  static deleteAddress(addressName) {
    return $.ajax({
      type: 'POST',
      url: globalThis.FFJP.addressDeleteEndPointUrl,
      data: JSON.stringify({
        customer_id: globalThis.FFJP.userID,
        name: addressName,
      }),
      crossDomain: true,
      dataType: 'json',
    })
  }
}
